import { BaseDto } from './base.dto';
import { ProductDto } from './product.dto';
import { RecipeDto } from './recipe.dto';


export class ProductRecipesDto extends BaseDto {

  effectiveDate: Date
  portions: number;
  recipe: RecipeDto;
  product: ProductDto;

  //just some variables to help to manage the logic
  costCalculated?: number;
  toAdd? = false;
  toUpdate? = false;

  constructor(
    recipe: RecipeDto,
    product: ProductDto,
    effectiveDate: Date,
    portions: number
  ) {
    super();
    this.recipe = recipe;
    this.product = product;
    this.effectiveDate = effectiveDate;
    this.portions = portions;
  }
}
